export default "__VITE_ASSET__CjJR2sCx__"